import { render, staticRenderFns } from "./StocksEquityFundsForm.vue?vue&type=template&id=a4a1021a&"
import script from "./StocksEquityFundsForm.vue?vue&type=script&lang=ts&"
export * from "./StocksEquityFundsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports